import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AccordionComponent } from '@ppl/ui';
import { AuthorizeDirective } from '../../../../shared/authorization/authorize.directive.';
import { ChecklistParticipantComponent } from '../../../leads/participant-checklist/participant-checklist.component';
import { ActivatedRoute } from '@angular/router';
import { ProviderChecklistComponent } from "../../../leads/provider-checklist/provider-checklist.component";
import { BaseComponent } from '../../../../shared/utils/base.component';
import { AuthorizationUtility } from '../../../../shared/authorization/auth.utility';
import { MEMBER_VIEW_PAGE_IDS, TABS } from '../../../../shared/constants/page.constants';
import { STATIC_DATA } from '../../../../shared/constants/static-data.constants';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'ppl-checklist',
  standalone: true,
  imports: [CommonModule, AccordionComponent, AuthorizeDirective, ChecklistParticipantComponent, ProviderChecklistComponent],
  templateUrl: './checklist.component.html',
  styleUrl: './checklist.component.css'
})
export class ChecklistComponent extends BaseComponent {
  tabId = TABS.Checklist;
  private _readonly = false;
  // When set true (e.g. the pended-list quick view), force the checklist read-only so no actions show.
  @Input() set readonly(value: boolean) {
    this._readonly = value;
    if (value) {
      this.isEditable = false;
    }
  }
  get readonly(): boolean {
    return this._readonly;
  }
  isParticipant = false;
  isEditable = false;
  pageId = MEMBER_VIEW_PAGE_IDS[this.userService.getFirstSegment()!];

  constructor(private route: ActivatedRoute, private authUtility: AuthorizationUtility, private userService: UserService) {
    super();
    this.isEditable = this.authUtility.isSectionEditable(this.pageId, this.tabId, TABS.Checklist);
    if (Object.prototype.hasOwnProperty.call(route.snapshot.data, 'isParticipant')){
      this.isParticipant = route.snapshot.data['isParticipant'];
    } else {
      if(this.userService.getLeadEntry() == 'participantEnrollment') {
        this.isParticipant = true;
      } else {
        if(this.userService.getLeadEntry() == 'participantEnrollment') {
          this.isParticipant = false;
        }
      }
    }
  }
}
